import { isTauriMode } from "./environmentDetector";

export const SCALE_KEY = "pos_screen_scale";
export const MIN_SCALE = 50;
export const MAX_SCALE = 150;
export const SCALE_STEP = 10;

export function readUiScale() {
  try {
    const saved = localStorage.getItem(SCALE_KEY);
    if (saved == null || saved === "") return 100;
    const parsed = parseInt(saved, 10);
    if (!Number.isFinite(parsed)) return 100;
    const next = Math.max(MIN_SCALE, Math.min(MAX_SCALE, parsed));
    if (String(next) !== saved) {
      localStorage.setItem(SCALE_KEY, String(next));
    }
    return next;
  } catch (error) {
    console.warn("[uiScale] Could not read saved zoom:", error);
  }
  return 100;
}

export function saveUiScale(percent) {
  const next = Math.max(MIN_SCALE, Math.min(MAX_SCALE, percent));
  try {
    localStorage.setItem(SCALE_KEY, String(next));
  } catch (error) {
    console.warn("[uiScale] Could not save zoom:", error);
  }
  return next;
}

function clearPosRootTransform() {
  const rootElement = document.getElementById("pos-root-container");
  if (!rootElement) return;
  rootElement.style.transform = "";
  rootElement.style.transformOrigin = "";
  rootElement.style.width = "";
  rootElement.style.height = "";
}

function applyDocumentZoom(scale) {
  document.documentElement.style.zoom = String(scale);
}

export async function applyUiScale(percent) {
  const next = Math.max(MIN_SCALE, Math.min(MAX_SCALE, percent));
  const scale = next / 100;
  clearPosRootTransform();

  if (isTauriMode()) {
    document.documentElement.style.zoom = "";
    try {
      const { getCurrentWebview } = await import("@tauri-apps/api/webview");
      await getCurrentWebview().setZoom(scale);
      return next;
    } catch (error) {
      console.warn("[uiScale] Webview zoom unavailable, using document zoom:", error);
    }
  }

  applyDocumentZoom(scale);
  return next;
}

export function applySavedUiScale() {
  return applyUiScale(readUiScale());
}
